import React from 'react';
import Dialog from 'components/pure/utils/Dialog';
import {OutlinedButton} from 'components/admin/topics/OutlinedButton';
import './EditOrCloneDialog.styl';

interface EditOrCloneDialogProps {
  open: boolean;
  onClone: React.MouseEventHandler;
  onClose(): void;
  onEdit: React.MouseEventHandler;
}

/**
 * Prompts the user to edit a profile used by multiple departments or clone it to create a new
 * profile.
 */
const EditOrCloneDialog: React.FC<EditOrCloneDialogProps> = ({open, onEdit, onClone, onClose}) => {
  return (
    <Dialog
      open={open}
      onRequestClose={onClose}
      contentClassName="admin-topics-page-edit-or-clone-dialog"
      title="Edit Profile">
      <div className="admin-topics-page-edit-or-clone-dialog-buttons">
        <OutlinedButton
          className="top"
          label="Edit for all teams using this profile"
          onClick={onEdit}
        />
        <OutlinedButton label="Clone and edit for this team" onClick={onClone} />
      </div>
    </Dialog>
  );
};

export default EditOrCloneDialog;
